import { Injectable, signal, computed } from '@angular/core';
import { Source } from '../../../@shared/components/custom-components/custom-sources/custom-sources.component';

export type SidePanelView = 'TOOL_DETAILS' | 'SOURCES' | 'FILE_PREVIEW' | 'CANVAS' | null;

export interface SidePanelContext {
    toolCallId?: string;
    source?: Source;
    file?: any;
    documentId?: string;
    message?: any;
    isEditable?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SidePanelService {
    // Core state
    isOpen = signal<boolean>(false);
    activeView = signal<SidePanelView>(null);
    context = signal<SidePanelContext>({});

    // Computed helpers
    isToolDetailsView = computed(() => this.activeView() === 'TOOL_DETAILS');
    isSourcesView = computed(() => this.activeView() === 'SOURCES');
    isFilePreviewView = computed(() => this.activeView() === 'FILE_PREVIEW');
    isCanvasView = computed(() => this.activeView() === 'CANVAS');

    /**
     * Open the side panel with a specific view and context
     */
    open(view: SidePanelView, context: SidePanelContext = {}): void {
        this.activeView.set(view);
        this.context.set(context || null);
        this.isOpen.set(true);
    }

    /**
     * Close the side panel and clear context
     */
    close(): void {
        this.isOpen.set(false);
        // Clear context after a short delay to allow animations
        setTimeout(() => {
            this.activeView.set(null);
            this.context.set({});
        }, 300);
    }

    /**
     * Toggle the side panel (close if open, otherwise do nothing)
     */
    toggle(): void {
        if (this.isOpen()) {
            this.close();
        }
    }

    /**
     * Clear all state
     */
    reset(): void {
        this.isOpen.set(false);
        this.activeView.set(null);
        this.context.set({});
    }
}
